(function () {
  'use strict';

  var MARK = 'data-sh-pack-thumbs';
  var timer = 0;
  var busy = false;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function splitCsv(s) {
    if (!s) return [];
    return String(s)
      .split(',')
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);
  }

  function packFromItem(item) {
    var props = item && item.properties;
    if (!props) return null;
    var thumbs = splitCsv(props._pack_thumbs || props.pack_thumbs || '');
    if (!thumbs.length) return null;
    return {
      key: item.key,
      title: item.product_title || item.title || '',
      thumbs: thumbs,
      titles: splitCsv(props._pack_titles || props.pack_titles || '')
    };
  }

  function ensureImg(box, src, alt) {
    if (!box || !src) return;
    var img = box.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      box.appendChild(img);
    }
    if (img.getAttribute('data-sh-pack-src') === src) return;
    img.src = src;
    img.alt = alt || 'Your pack';
    img.loading = 'lazy';
    img.setAttribute('data-sh-pack-src', src);
    box.classList.add('is-pack-preview');
  }

  function buildGrid(pack) {
    var wrap = document.createElement('div');
    wrap.className = 'sh-pack-thumbs';
    wrap.setAttribute(MARK, pack.key || '');

    var label = document.createElement('div');
    label.className = 'sh-pack-thumbs__label';
    label.textContent = 'Your pack · ' + pack.thumbs.length + ' stickers';
    wrap.appendChild(label);

    var grid = document.createElement('div');
    grid.className = 'sh-pack-thumbs__grid';
    pack.thumbs.forEach(function (url, i) {
      var cell = document.createElement('div');
      cell.className = 'sh-pack-thumbs__cell';
      var t = (pack.titles[i] || '').replace(/\u201A/g, ',');
      if (t) cell.title = t;
      var img = document.createElement('img');
      img.src = url;
      img.alt = t || 'Pack sticker ' + (i + 1);
      img.loading = 'lazy';
      img.decoding = 'async';
      cell.appendChild(img);
      grid.appendChild(cell);
    });
    wrap.appendChild(grid);
    return wrap;
  }

  function infoColumn(row) {
    if (!row) return null;
    // Prefer the content column, never the 86px image cell
    var kids = row.children;
    for (var i = 0; i < kids.length; i++) {
      if (!kids[i].classList.contains('sh-cart-line__img')) return kids[i];
    }
    return (
      row.querySelector('.sh-cart-line__title') &&
      row.querySelector('.sh-cart-line__title').parentElement
    );
  }

  function applyToDrawer(cart) {
    var wrap = document.querySelector('[data-sh-cart-items]');
    if (!wrap) return;
    var rows = wrap.querySelectorAll('.sh-cart-line');
    (cart.items || []).forEach(function (item, i) {
      var pack = packFromItem(item);
      var row = rows[i];
      if (!pack || !row) return;

      // Keep the product featured image (Custom Pack beer box) as the line thumbnail.
      // Selected stickers render in the grid under the title.
      var info = infoColumn(row);
      if (!info) return;

      var existing = info.querySelector('[' + MARK + ']');
      var sig = pack.thumbs.join('|');
      if (existing && existing.getAttribute('data-sh-pack-sig') === sig) {
        // already current
      } else {
        var block = buildGrid(pack);
        block.setAttribute('data-sh-pack-sig', sig);
        if (existing) existing.replaceWith(block);
        else {
          var price = info.querySelector('.sh-cart-line__price');
          if (price) info.insertBefore(block, price);
          else {
            var bottom = info.querySelector('.sh-cart-line__bottom');
            if (bottom) info.insertBefore(block, bottom);
            else info.appendChild(block);
          }
        }
      }
    });
  }

  function applyToCartPage(cart) {
    (cart.items || []).forEach(function (item) {
      var pack = packFromItem(item);
      if (!pack) return;

      // Match rows by product title text
      var titleNodes = document.querySelectorAll(
        '.cart__product-title, [data-cart-item-title], .product-details a, td a[href*="/products/"]'
      );
      var row = null;
      for (var i = 0; i < titleNodes.length; i++) {
        var t = (titleNodes[i].textContent || '').trim();
        if (pack.title && t.indexOf(pack.title) !== -1) {
          row =
            titleNodes[i].closest('tr, .cart__row, [data-cart-item], .cart-item') ||
            titleNodes[i].closest('td') ||
            titleNodes[i].parentElement;
          break;
        }
      }
      if (!row) return;

      // Leave the pack product image (beer box) alone on the cart page.

      var host =
        row.querySelector('.product-details, .cart__meta, td:nth-child(2)') || row;
      // Don't inject into a table image cell
      if (host && host.querySelector && host.querySelector('img') && !host.querySelector('.product-details, .cart__meta')) {
        host = row;
      }
      var existing = host.querySelector('[' + MARK + '="' + CSSEscape(pack.key) + '"]') ||
        host.querySelector('[' + MARK + ']');
      var sig = pack.thumbs.join('|');
      if (existing && existing.getAttribute('data-sh-pack-sig') === sig) {
        // already current
      } else {
        var block = buildGrid(pack);
        block.setAttribute('data-sh-pack-sig', sig);
        block.style.width = '100%';
        block.style.maxWidth = '100%';
        block.style.gridColumn = '1 / -1';
        if (existing) existing.replaceWith(block);
        else host.appendChild(block);
      }
    });
  }

  function CSSEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/"/g, '\\"');
  }

  async function apply() {
    if (busy) return;
    busy = true;
    try {
      var r = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!r.ok) return;
      var cart = await r.json();
      applyToDrawer(cart);
      applyToCartPage(cart);
    } catch (e) {
      console.warn('[PackCartThumbs]', e);
    } finally {
      busy = false;
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 40);
  }

  function init() {
    var wrap = document.querySelector('[data-sh-cart-items]');
    if (wrap) {
      new MutationObserver(schedule).observe(wrap, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sh-cart-open]')) schedule();
    });
    document.addEventListener('sh:cart:updated', schedule);
    document.addEventListener('sh:cart:closed', schedule);
    schedule();
    setTimeout(schedule, 600);
    setTimeout(schedule, 1800);
  }

  ready(init);
  window.StickerheadsPackCartThumbs = { refresh: schedule };
})();
